/**
 * 埋点系统入口
 * 提供全局挂载功能
 */

import type { TrackingOptions } from './types';

import {
  clearTraceId,
  destroyTracking,
  initTracking,
  initPageStayTracking,
  markUserAction,
  reportPageStayBeforeUnload,
  setTraceId,
  track,
  trackImmediate,
  trackPageStay,
} from './core';

export * from './constants';
export * from './types';
export { track, trackImmediate, trackPageStay, setTraceId, clearTraceId, initTracking, destroyTracking, initPageStayTracking, markUserAction, reportPageStayBeforeUnload };

/**
 * 挂载埋点系统到全局 window 对象
 * 挂载后可在任何地方直接调用：
 * - window.track(eventType, eventData)
 * - window.trackPageStay(pageStayData)
 * - window.setTraceId(traceId)
 * - window.clearTraceId()
 */
export function mountTrackingToGlobal(options?: TrackingOptions): void {
  if (typeof window === 'undefined') {
    console.warn('[Tracking] 非浏览器环境，无法挂载到 window');
    return;
  }

  // 初始化埋点系统
  initTracking(options);

  // 挂载到 window
  window.track = track;
  window.trackImmediate = trackImmediate;
  window.trackPageStay = trackPageStay;
  window.setTraceId = setTraceId;
  window.clearTraceId = clearTraceId;
  window.markUserAction = markUserAction;
  window.initPageStayTracking = initPageStayTracking;
  window.reportPageStay = reportPageStayBeforeUnload;

  if (options?.debug) {
    console.log('[Tracking] 已挂载到 window，可直接调用 window.track()');
  }
}

/**
 * 从全局 window 对象卸载埋点系统
 */
export function unmountTrackingFromGlobal(): void {
  if (typeof window === 'undefined') {
    return;
  }

  destroyTracking();

  // 从 window 移除
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  delete (window as any).track;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  delete (window as any).trackImmediate;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  delete (window as any).trackPageStay;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  delete (window as any).setTraceId;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  delete (window as any).clearTraceId;
}
